export const PREDEFINED_LAST_DAY_COUNTS = [7, 14, 30, 90, 180, 365] as const;

export const DATE_PICKER_PORTAL_ID = 'wm-datepicker';
